var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uello-app"},[_c('u-sidebar'),_c('u-header'),_c('div',{staticClass:"route-container bg-white",style:({ height: _vm.height })},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }